import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { setPlayerPreview } from "../../../actions/index";

// Entrypoint for all previews audios.
function ConnectedPreviewWrapper({ audioPreview, setPlayerPreview }) {
  useEffect( () => {
    setPlayerPreview(document.getElementById(`preview_audio`));
  }, [setPlayerPreview])
  return <audio src={audioPreview} loop={false} id={`preview_audio`} />
}

const PreviewWrapper = connect(
  state => ({
    audioPreview: state.audioPreview
  }),
  dispatch => ({
    setPlayerPreview: (player) => dispatch(setPlayerPreview(player)),
  })
)(ConnectedPreviewWrapper);

export default PreviewWrapper;
